export const GROUP_FAMILIES = "GROUP_FAMILIES";
export const RESET_FAMILIES = "RESET_FAMILIES";
export const REMOVE_FAMILY = "REMOVE_FAMILY";
